import { render, staticRenderFns } from "./DataDive.vue?vue&type=template&id=1f46e71e&scoped=true&"
import script from "./DataDive.vue?vue&type=script&lang=js&"
export * from "./DataDive.vue?vue&type=script&lang=js&"
import style0 from "./DataDive.vue?vue&type=style&index=0&id=1f46e71e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f46e71e",
  null
  
)

export default component.exports